import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

export const LlmDataWarning: React.FC = () => {
  const { darkMode } = useTheme();
  const { user } = useAuth();

  // Addendum B: scope localStorage key per user ID
  const storageKey = user?.id
    ? `llm_data_warning_dismissed_${user.id}`
    : 'llm_data_warning_dismissed';

  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    setDismissed(localStorage.getItem(storageKey) === 'true');
  }, [storageKey]);

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(storageKey, 'true');
    setDismissed(true);
  };

  return (
    <div
      className={`mx-4 mb-4 p-4 rounded-lg border flex items-start justify-between ${
        darkMode
          ? 'bg-amber-900/20 border-amber-700 text-amber-200'
          : 'bg-amber-50 border-amber-200 text-amber-800'
      }`}
    >
      <div className="flex items-start space-x-3">
        <FiAlertTriangle className="mt-0.5 flex-shrink-0" size={18} />
        <div className="text-sm">
          <strong>Third-party AI processing:</strong> Your input is processed
          by third-party AI providers. Do not enter sensitive personal or
          regulated data.{' '}
          <Link
            to="/legal?doc=privacy"
            className="underline hover:no-underline"
          >
            Learn more
          </Link>
        </div>
      </div>
      <button
        onClick={handleDismiss}
        className="ml-4 p-1 rounded hover:bg-black/10 flex-shrink-0"
        aria-label="Dismiss warning"
      >
        <FiX size={16} />
      </button>
    </div>
  );
};
